import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface IChangePlanPayload {
  plan_id: number;
}

import { IChangePlanPreviewResponse } from "../../interfaces";

export interface IChangePlanPayload {
  plan_id: number;
}

export const useChangePlan = () => {
  return useMutation<IChangePlanPreviewResponse, Error, IChangePlanPayload>({
    mutationFn: async (payload) =>
      httpService.post<IChangePlanPreviewResponse>(
        API_CONFIG.path.stripeChangePlan,
        payload as unknown as Record<string, unknown>
      ),
  });
};
